<template>
    <nav class="bg-white border-b border-gray-200 px-4 sm:px-6 py-3">
        <div class="flex items-center justify-between">
            <span class="font-bold text-gray-800">Sirimmatrix</span>

            <!-- Desktop links -->
            <div class="hidden sm:flex items-center gap-8">
                <div class="flex items-center gap-6">
                    <router-link :to="{ name: 'adminDashboard', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide" :class="active === 'dashboard' ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900'">Contas</router-link>
                    <router-link :to="{ name: 'adminMrr', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide" :class="active === 'mrr' ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900'">Receita</router-link>
                    <router-link :to="{ name: 'adminEmails', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide" :class="active === 'emails' ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900'">Emails</router-link>
                    <router-link :to="{ name: 'adminCoupons', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide" :class="active === 'coupons' ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900'">Cupons</router-link>
                </div>
                <button @click="logout" class="text-sm font-semibold uppercase tracking-wide text-red-500 hover:text-red-600">Sair</button>
            </div>

            <!-- Mobile hamburger -->
            <button class="sm:hidden p-2 -mr-2 text-gray-600" @click="open = !open" aria-label="Menu">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path v-if="!open" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Mobile menu -->
        <div v-if="open" class="sm:hidden mt-3 pb-1 flex flex-col gap-1 border-t border-gray-100 pt-3">
            <router-link :to="{ name: 'adminDashboard', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide py-2" :class="active === 'dashboard' ? 'text-gray-900' : 'text-gray-600'" @click="open = false">Contas</router-link>
            <router-link :to="{ name: 'adminMrr', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide py-2" :class="active === 'mrr' ? 'text-gray-900' : 'text-gray-600'" @click="open = false">Receita</router-link>
            <router-link :to="{ name: 'adminEmails', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide py-2" :class="active === 'emails' ? 'text-gray-900' : 'text-gray-600'" @click="open = false">Emails</router-link>
            <router-link :to="{ name: 'adminCoupons', params: { uuid } }" class="text-sm font-semibold uppercase tracking-wide py-2" :class="active === 'coupons' ? 'text-gray-900' : 'text-gray-600'" @click="open = false">Cupons</router-link>
            <button @click="logout" class="text-sm font-semibold uppercase tracking-wide text-red-500 text-left py-2">Sair</button>
        </div>
    </nav>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AdminAuthService from '@/services/admin/AdminAuthService';

export default {
    name: 'AdminNavbar',
    props: {
        active: { type: String, default: '' }
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const uuid = computed(() => route.params.uuid);
        const open = ref(false);

        function logout() {
            AdminAuthService.logout();
            router.push({ name: 'adminLogin', params: { uuid: uuid.value } });
        }

        return { uuid, open, logout };
    }
};
</script>
